module.exports = __webpack_public_path__ + "img/caroff_2.ec243cdc.png";